import { I as Icon } from './definition28.js';
import { s as slotted } from './slotted.js';
import { h as html, a as attr } from './vivid-element.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class AffixIcon {
}
__decorateClass([
  attr
], AffixIcon.prototype, "icon");
__decorateClass([
  attr({ mode: "fromView" })
], AffixIcon.prototype, "iconSlottedContent");
class AffixIconWithTrailing extends AffixIcon {
  constructor() {
    super(...arguments);
    this.iconTrailing = false;
  }
}
__decorateClass([
  attr({
    mode: "boolean",
    attribute: "icon-trailing"
  })
], AffixIconWithTrailing.prototype, "iconTrailing");
const IconWrapper = {
  Slot: false,
  Span: true
};
const IconAriaHidden = {
  Hidden: "true"};
const affixIconTemplateFactory = (context) => {
  const iconTag = context.tagFor(Icon);
  return (icon, slottedState = IconWrapper.Span, ariaHidden = IconAriaHidden.Hidden) => {
    if (!icon && !slottedState) {
      return html`<slot
				name="icon"
				aria-hidden="${() => ariaHidden}"
				${slotted("iconSlottedContent")}
			></slot>`;
    }
    if (!icon && slottedState) {
      return null;
    }
    const iconTemplate = html`<${iconTag} :name="${() => icon}"></${iconTag}>`;
    return slottedState ? html`<span class="icon" aria-hidden="${() => ariaHidden}"
					>${iconTemplate}</span
			  >` : html`<slot name="icon" aria-hidden="${() => ariaHidden}"
					>${iconTemplate}</slot
			  >`;
  };
};

export { AffixIconWithTrailing as A, IconWrapper as I, affixIconTemplateFactory as a, AffixIcon as b };
